module.exports = {
	methods: {
		navigateTo(page, auth = true) {
			uni.vk.navigateTo(page, auth)
		},
		redirectTo(page, auth = true) {
			uni.vk.redirectTo(page, auth)
		},
		goWebview(url, title) {





			this.navigateTo(
				"/pages/webview/webview?url=" + encodeURIComponent(url) + "&title=" + title,
				false
			)

		}
	}
}
